import { ApiSettings, AppSettings } from "application";
import StorageService from "infrastructure/common/storage";

const downloadMyDetailDocuments = (documents) => {
  const token = StorageService.getItem(AppSettings.ticketName);
  const data = documents?.map((doc) => doc.id).join(",");
  window.open(ApiSettings.downloadMyDetailDocuments(token, data), "_blank");
};

export default downloadMyDetailDocuments;
